import React from "react";
import { object, string } from "prop-types";

import ProfileMenuItem from "../ProfileMenuItem";

import "./profile-menu-mobile.m.css";

const ProfileMenuMobile = ({ type = "profile", member }) => {
  return (
    <div className="profile-mobile-menu">
      <div styleName="wrapper">
        <ProfileMenuItem label="My Profile" isActive={type === "profile"} href="/profile" />
        <div>
          <ProfileMenuItem href="/profile/edit" label="Edit Profile" isActive={type === "edit-profile"} />
        </div>
        {member && !member["verification-status"].includes("social-") && (
          <ProfileMenuItem
            href="/profile/change-password"
            label="Change Password"
            isActive={type === "change-password"}
          />
        )}
        <ProfileMenuItem label="My Comments" isActive={type === "comments"} href="/my-comments" />
        <ProfileMenuItem label="Saved Articles" isActive={type === "saved_news"} href="/saved" />
      </div>
    </div>
  );
};

ProfileMenuMobile.propTypes = {
  type: string,
  member: object,
};

export default ProfileMenuMobile;
